module.exports = __webpack_public_path__ + "static/media/48397043_2309077622500749_4886052738363817984_o-thumb.d387eabc.jpg";